(function ($) {
	// On Dom Ready
	$(function () {
		// Swiper slider
		const slider_element_selector = ".hero-home .swiper";

		// disable if only one slide
		if ($(slider_element_selector).find(".swiper-slide").length > 1) {
			const the_slider = new Swiper(slider_element_selector, {
				loop: true,
				slidesPerView: 1,
				lazy: true,
				simulateTouch: false,
				effect: "fade",

				autoplay: {
					delay: 3000,
				},
				speed: 700,

				// If we need pagination
				pagination: false,

				// Navigation arrows
				navigation: false,
			});

			const color_classes = [
				"has-theme-green-color",
				"has-theme-citrine-color",
				"has-theme-purple-color",
			];
			the_slider.on("slideChange", function () {
				const index_currentSlide = this.activeIndex;
				const currentSlide = this.slides[index_currentSlide];
				const currentSlideColoredText = $(currentSlide).data("colored-text");

				$(".hero-colored-text-search-wrapper .colored-text").fadeOut(
					350,
					function () {
						
						color_classes.forEach((color_class) => {
							$(`.hero-colored-text-search-wrapper .colored-text`).removeClass(
								`${color_class}`
							);
						});

						const color_index = index_currentSlide - 1;
						const current_color_index = color_index % 3;
						$(`.hero-colored-text-search-wrapper .colored-text`).addClass(
							`${color_classes[current_color_index]}`
						);
						
						$(this).html(currentSlideColoredText).fadeIn(700);
						
					}
				);
			});

			// play/pause swiper slider on button click
			$(slider_element_selector + " .play-pause-slideshow").on(
				"click",
				function (e) {
					e.preventDefault();
					$(this).toggleClass("active");

					if ($(this).hasClass("active")) {
						the_slider.autoplay.stop();
					} else {
						the_slider.autoplay.start();
					}
				}
			);
		} else {
			$(slider_element_selector).addClass("disabled");
		}

		// Toggle dropdown links
		$(".dropdown-links .dropdown-button").on("click", function (e) {
			e.preventDefault();
			$(this).parent().addClass("active");
			setTimeout(function () {
				$(".dropdown-links .search-form-wrapper input[type='text']").focus();
			}, 300);
		});

		$(".hero-home .dropdown-search-form .btn-clear-search").on(
			"click",
			function (e) {
				e.preventDefault();
				$('.hero-home .dropdown-search-form input[name="s"]').val("");
				$(".dropdown-links").removeClass("active");
			}
		);

		// Hide dropdown links when clicked outside
		$(document).on("click", function (e) {
			var $target = $(e.target);

			if (
				!$target.closest(".dropdown-links").length ||
				$target.hasClass("hero-overlay") ||
				($target.hasClass("dropdown-links") && $target.hasClass("active"))
			) {
				$(".dropdown-links").removeClass("active");
			}
		});
	});
})(jQuery);
